export default "__VITE_ASSET__Cx3XUCt2__"